// src/pages/Vision/VisionBottom.js

import { useRefs } from '../../context/RefContext'
import Aos from 'aos';
import 'aos/dist/aos.css'; // Corrected AOS CSS import
import { useEffect } from 'react';
import { Trans } from "@lingui/react/macro";
import './VisionBottom-A.scss'
import { Link, useNavigate } from 'react-router-dom';

const VisionBottom = () =>
{
    useEffect(() =>
    {
        Aos.init({ duration: 1000, once: true, easing: 'ease-in-out' });
    }, []); // Empty dependency array means this runs once on mount

    const { weRef } = useRefs();

    return (
        <div className='vision-bottom-section'>
            <div className='developments-section' data-aos="fade-in"> <Link
                            to="/desarrollos" className="developments-links" ><div className='block'><Trans>CONOZCA</Trans></div>
                <div className='block outline'><Trans>NUESTROS DESARROLLOS</Trans></div></Link>
            </div>
            <div className='existing-text-layer'>
                <div ref={weRef}  className='vision-content-block'>
                <p  className="block"><Trans>
              NUESTRO
                </Trans></p>
                <p  className="block outline"><Trans>
              EQUIPO
                </Trans></p> 
                </div>
            </div>
        </div>
    );
};

export default VisionBottom;
